import { ExternalCalendarEvent } from '@griply/types';
import { parse } from 'date-fns';

// The decode half of the cached-event boundary shape (`toExternalEventBoundary` encodes it).
// A date-only boundary is a calendar day, so it resolves to LOCAL midnight: `new Date('2026-07-20')`
// would yield UTC midnight and shift the event a day against anything keyed off `startOfDay()`.
export const getExternalEventBoundaryDate = (
  boundary: ExternalCalendarEvent['start'],
): Date =>
  boundary.dateTime
    ? new Date(boundary.dateTime)
    : parse(boundary.date!, 'yyyy-MM-dd', new Date());
